import { UseScreenReaderStatusReturn } from './types';

const useScreenReaderStatus = (): UseScreenReaderStatusReturn => ({
  screenReaderEnabled: false,
});

export default useScreenReaderStatus;
